import { types, actions } from './requests'
export const DELETEBADGESCAN_TYPES = {
    ...types('DELETEBADGESCAN'),
}
export const DELETEBADGESCAN_ACTIONS = {
    ...actions('DELETEBADGESCAN'),
}